<template lang='pug'>
.popup
  .popup-overlay(@click="closePopup")
  .popup-body
    .popup-content
      .popup-simple
        i(:class="'icon-popup-' + iconType")
        span.popup-textSimple {{ popupSimpleText }}
</template>
<script>
export default {
  props: {
    popupSimpleText: String,
    iconType: String
  },
  methods: {
    closePopup() {
      this.$emit("closePopup")
    }
  }
}
</script>